import { createValidator, required } from 'util/validation'

import { IvcfAplicacaoModel } from '../../model-ivcf'

export const ivcfValidator = createValidator<IvcfAplicacaoModel>({
  ALCANCE_PREENSAO_PINCA_PERGUNTA_1: required,
  ALCANCE_PREENSAO_PINCA_PERGUNTA_2: required,
  AUDICAO_PERGUNTA_1: required,
  AVD_BASICA_PERGUNTA_1: required,
  AVD_INSTRUMENTAL_PERGUNTA_1: required,
  AVD_INSTRUMENTAL_PERGUNTA_2: required,
  AVD_INSTRUMENTAL_PERGUNTA_3: required,
  CAPACIDADE_PERGUNTA_1: required,
  CAPACIDADE_PERGUNTA_3: required,
  CAPACIDADE_PERGUNTA_4: required,
  CAPACIDADE_PERGUNTA_5: required,
  COGNICAO_PERGUNTA_1: required,
  COGNICAO_PERGUNTA_3: required,
  COGNICAO_PERGUNTA_2: required,
  COMORBIDADE_PERGUNTA_1: required,
  COMORBIDADE_PERGUNTA_2: required,
  COMORBIDADE_PERGUNTA_3: required,
  CONTINENCIA_PERGUNTA_1: required,
  HUMOR_PERGUNTA_1: required,
  HUMOR_PERGUNTA_2: required,
  MARCHA_PERGUNTA_1: required,
  MARCHA_PERGUNTA_2: required,
  PERCEPCAO_SAUDE_PERGUNTA_1: required,
  VISAO_PERGUNTA_1: required,
})
